import * as actionTypes from "./actionTypes";

export const setChatAccessToken = (serviceId, channelSID, accessToken) => ({
    type: actionTypes.SET_CHAT_ACCESS_TOKEN,
    serviceId,
    channelSID,
    accessToken,
});
